import { Page } from "@/models/page-models/Page";

export const ProductsEdit: Page = {
  "path": "products/:productId",
  "name": "View/Update Product",
  "props": {
    "data": {
      "title": "View/Update Product",
      "printable": "FALSE",
      "url": "products/:productId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.product.customer.name",
                  "label": "Customer",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,customerAlias,{{formData.product.customer}})"
                },
                {
                  "type": "label",
                  "variable": "formData.product.updatedAt",
                  "label": "Last Updated",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.product.updatedAt}},show-time)"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.product._id",
                  "label": "Product ID"
                },
                {
                  "type": "label",
                  "variable": "formData.product",
                  "label": "Status",
                  "labelType": "formula",
                  "formula": "fn(CONDITIONAL,{{formData.product.isDeleted}},Deleted,fn(HELPER_FN,productStatus,{{formData.product}}))"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.product.createdBy.displayName",
                  "label": "Created By"
                },
                {
                  "type": "label",
                  "variable": "formData.product.updatedBy.displayName",
                  "label": "Last Updated By"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.product.readyStock",
                  "label": "Ready Stock",
                  "labelType": "formula",
                  "formula": "fn(CONCAT,fn(HELPER_FN,numFormat,{{formData.product.readyStock}},true), ,{{formData.product.unit.unit2}},(s))",
                  "showIf": "{{formData.product.unit.unit2}}"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "groupItems": [
            {
              "name": "3a",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.product.alias",
                  "label": "Alias",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.product.customerItemId",
                  "label": "Customer Item Code",
                  "disabled": "FALSE",
                  "showIf": "{{formData.product.productLine}}"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "disabled": "fn(NOT,fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,QA_TECHNICAL_EXECUTIVE)),||,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_DEPARTMENT,SALES))))",
          "label": "Customer Specs"
        },
        {
          "groupItems": [
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.productLine",
                  "label": "Product Line",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetFormData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "formData.product",
                        "arg2Key": "sourceFn",
                        "arg2Value": "getFormValues",
                        "arg3Key": "destinationKey",
                        "arg3Value": "formData.product"
                      },
                      "name": "resetFormData"
                    }
                  ],
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copySelectedProductLine",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selected",
                        "arg3Key": "destinationKeyType",
                        "arg3Value": "Object"
                      },
                      "name": "copySelectedProductLine"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.productLines.data.0.data",
                  "itemText": "name",
                  "itemValue": "name"
                }
              ],
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),||,fn(MATCH_ROLE,Customer Service | Artwork))"
            },
            {
              "name": "3a",
              "pageItems": [
                {
                  "type": "checkbox",
                  "variable": "formData.product.customerSample.sampleAvailable",
                  "label": "Customer Sample Available?",
                  "disabled": "FALSE",
                  "showIf": "{{formData.product.productLine}}"
                }
              ],
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),||,fn(MATCH_ROLE,Customer Service | Artwork))"
            },
            {
              "name": "3b",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "formData.product.customerSample.pictures",
                  "disabled": "FALSE",
                  "showIf": "{{formData.product.customerSample.sampleAvailable}}",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "fileupload",
                          "variable": "picture",
                          "label": "Sample Picture",
                          "disabled": "FALSE",
                          "color": "primary",
                          "previewType": "no-preview"
                        }
                      ]
                    }
                  ]
                }
              ],
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),||,fn(MATCH_ROLE,Customer Service | Artwork))"
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.form",
                  "label": "Form",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copySelectedShapeData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selected.data",
                        "arg3Key": "destinationKeyType",
                        "arg3Value": "Object",
                        "arg4Key": "append",
                        "arg4Value": "TRUE"
                      },
                      "name": "copySelectedShapeData"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.form}}",
                  "items": "fetchedData.selected.data.form",
                  "itemText": "title",
                  "itemValue": "title"
                }
              ],
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),||,fn(MATCH_ROLE,Customer Service | Artwork))"
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.shape",
                  "label": "Shape",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copySelectedShapeData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selected.data",
                        "arg3Key": "destinationKeyType",
                        "arg3Value": "Object",
                        "arg4Key": "append",
                        "arg4Value": "TRUE"
                      },
                      "name": "copySelectedShapeData"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.shapes}}",
                  "items": "fetchedData.selected.data.shapes",
                  "itemText": "title",
                  "itemValue": "title"
                }
              ],
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),||,fn(MATCH_ROLE,Customer Service | Artwork))"
            },
            {
              "name": "6b",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.corrugatedPaper.fluteType",
                  "label": "Flute Type",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.attributes.fluteType}}",
                  "items": "fetchedData.selected.data.attributes.fluteType"
                }
              ],
              "showIf": "fn(LOGICAL,'{{formData.product.productLine}}',==,'Corrugated Paper')",
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),||,fn(MATCH_ROLE,Customer Service | Artwork))"
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "dynamicGroup",
                  "variable": "formData.product.size",
                  "label": "Size",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.attributes.size}}",
                  "items": "fetchedData.selected.data.attributes.size",
                  "config": {
                    "type": "input",
                    "unit": "__item.unit",
                    "label": "__item.value",
                    "variable": "__item.value"
                  }
                },
                {
                  "type": "label",
                  "label": "Total Diameter",
                  "unit": "mm",
                  "showIf": "{{formData.product.size.BDIA}}",
                  "labelType": "formula",
                  "formula": "fn(SUM,{{formData.product.size.BDIA}},fn(MULTIPLY,{{formData.product.size.HEIGHT}},2))"
                }
              ],
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),||,fn(MATCH_ROLE,Customer Service | Artwork))"
            },
            {
              "name": "8b(1)",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Artwork Specs"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.printing.printType}},'),==,'Printed')"
            },
            {
              "name": "8b(2)",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.printing.printType",
                  "label": "Printing",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.attributes.showPrinting}}",
                  "items": "[{\"text\":\"Yes\",\"value\":\"Printed\"},{\"text\":\"No\",\"value\":\"Plain\"}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.product.printing.windingDirection",
                  "label": "Winding Direction",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.printing.printType}},'),==,'Printed')",
                  "items": "[\"C1\",\"C2\",\"C3\",\"C4\",\"C5\",\"C6\",\"C7\",\"C8\",\"Manual\"]",
                  "dropdownType": "static"
                }
              ],
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),&&,fn(NOT,fn(MATCH_ROLE,Customer Service | Artwork)))"
            },
            {
              "name": "8b(3)",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "formData.product.printing.design",
                  "disabled": "fn(MATCH_ROLE,SALES_ACCOUNT_EXECUTIVE)",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "input",
                          "variable": "designName",
                          "label": "Design Name",
                          "disabled": "FALSE"
                        },
                        {
                          "type": "fileupload",
                          "variable": "designFile",
                          "label": "Artwork Proposal",
                          "disabled": "FALSE",
                          "color": "primary",
                          "previewType": "no-preview"
                        }
                      ]
                    }
                  ]
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.printing.printType}},'),==,'Printed')",
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),&&,fn(NOT,fn(MATCH_ROLE,Customer Service | Artwork)))"
            },
            {
              "name": "3a",
              "pageItems": [
                {
                  "type": "checkbox",
                  "variable": "formData.product.printing.artworkApproval.approved",
                  "label": "Artwork Approved?",
                  "disabled": "fn(NOT,fn(MATCH_DEPARTMENT,SALES))",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.printing.printType}},'),==,'Printed')"
                },
                {
                  "type": "fileupload",
                  "variable": "formData.product.printing.artworkApproval.approvalProof",
                  "label": "Customer Artwork Approval",
                  "disabled": "fn(NOT,fn(MATCH_DEPARTMENT,SALES))",
                  "color": "primary",
                  "previewType": "no-preview"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.printing.printType}},'),==,'Printed')",
              "disabled": "fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}}))"
            },
            {
              "name": "8b(4)",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.product.printing.noOfColors",
                  "label": "No Of Colors",
                  "disabled": "FALSE"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.product.printing.varnish",
                  "label": "Varnish",
                  "disabled": "FALSE",
                  "items": "[\"None\",\"Matt\",\"Glossy\",\"Tactile\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.product.printing.spotVarnish",
                  "label": "Spot Varnish",
                  "disabled": "FALSE",
                  "items": "[\"None\",\"Matt\",\"Glossy\",\"Tactile\"]",
                  "dropdownType": "static"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.printing.printType}},'),==,'Printed')",
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),&&,fn(NOT,fn(MATCH_ROLE,Customer Service | Artwork)))"
            },
            {
              "name": "8b(5)",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.printing.lamination",
                  "label": "Lamination",
                  "disabled": "FALSE",
                  "items": "[{\"text\":\"Yes\",\"value\":true},{\"text\":\"No\",\"value\":false}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.product.printing.screen",
                  "label": "Screen",
                  "disabled": "FALSE",
                  "items": "[{\"text\":\"Yes\",\"value\":true},{\"text\":\"No\",\"value\":false}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.product.printing.foil",
                  "label": "Foil",
                  "disabled": "FALSE",
                  "items": "[\"None\",\"Gold\",\"Silver\"]",
                  "dropdownType": "static"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.printing.printType}},'),==,'Printed')",
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),&&,fn(NOT,fn(MATCH_ROLE,Customer Service | Artwork)))"
            },
            {
              "name": "8(1)",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Material Specs"
                }
              ]
            },
            {
              "name": "1a",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.bakingMold.plumCake.fluteType",
                  "label": "Flute Type",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.attributes.fluteType}}",
                  "items": "fetchedData.selected.data.attributes.fluteType"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,'{{formData.product.productLine}}',==,'Baking Mold'),&&,fn(LOGICAL,'{{formData.product.form}}',==,'Plum Cake'))",
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),||,fn(MATCH_ROLE,Customer Service | Artwork))"
            },
            {
              "name": "1b",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.bakingMold.panettone.baseMaterial.fluteType",
                  "label": "Base Flute Type",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.attributes.baseMaterial.fluteType}}",
                  "items": "fetchedData.selected.data.attributes.baseMaterial.fluteType"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.product.bakingMold.panettone.edgeType",
                  "label": "Edge Type",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.attributes.edgeMaterialType}}",
                  "items": "fetchedData.selected.data.attributes.edgeMaterialType"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.product.bakingMold.panettone.hardEdgeMaterial.fluteType",
                  "label": "Edge Flute Type",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,'{{formData.product.bakingMold.panettone.edgeType}}',==,'Hard Edge')",
                  "items": "fetchedData.selected.data.attributes.hardEdgeMaterial.fluteType"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,'{{formData.product.productLine}}',==,'Baking Mold'),&&,fn(LOGICAL,'{{formData.product.form}}',==,'Panettone'))",
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),||,fn(MATCH_ROLE,Customer Service | Artwork))"
            },
            {
              "name": "1c",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.product.corrugatedPaper.fluteType",
                  "label": "Flute Type",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selected.data.attributes.fluteType}}",
                  "items": "fetchedData.selected.data.attributes.fluteType"
                }
              ],
              "showIf": "fn(LOGICAL,'{{formData.product.productLine}}',==,'Coffee Cup Sleeve')",
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),||,fn(MATCH_ROLE,Customer Service | Artwork))"
            },
            {
              "name": "21",
              "pageItems": [
                {
                  "type": "salesRmAlias",
                  "variable": "formData.product.rmAlias",
                  "showIf": "{{fetchedData.selected.data.attributes.showMaterialAlias}}",
                  "disabled": "fn(MATCH_ROLE,Customer Service | Artwork)",
                  "items": "fetchedData.rmAliases.data",
                  "productDataVariable": "formData.product"
                }
              ],
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),&&,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.product.status}},'),!=,'Draft'),||,fn(NOT,{{fetchedData.allowDraftProductEdit}})))"
            },
            {
              "name": "4b(1)",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Wet Wipes Specs"
                }
              ],
              "showIf": "fn(LOGICAL,'{{formData.product.productLine}}',==,'Wet Wipes')"
            },
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.product.wetWipes.shape",
                  "label": "Sachet Shape",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.product.wetWipes.sachetStructure",
                  "label": "Sachet Structure",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.product.wetWipes.tissueLength",
                  "label": "Tissue Length",
                  "unit": "mm",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.product.wetWipes.tissueWidth",
                  "label": "Tissue Width",
                  "unit": "mm",
                  "disabled": "FALSE"
                }
              ],
              "showIf": "fn(LOGICAL,'{{formData.product.productLine}}',==,'Wet Wipes')",
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),||,fn(MATCH_ROLE,Customer Service | Artwork))"
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "custom_PackingMode",
                  "variable": "formData.product.packingMode",
                  "label": "Packing",
                  "disabled": "FALSE",
                  "showIf": "{{formData.product.productLine}}",
                  "config": {
                    "productLine": "fetchedData.selected",
                    "sellingUnit": "formData.product.unit.unit2"
                  }
                }
              ],
              "disabled": "fn(LOGICAL,fn(NOT,fn(HELPER_FN,productEditFlag,{{formData.product}})),||,fn(MATCH_ROLE,Customer Service | Artwork))"
            }
          ],
          "type": "genericGroup",
          "label": "Technical Specs",
          "disabled": "fn(NOT,fn(LOGICAL,fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,QA_TECHNICAL_EXECUTIVE)),||,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_DEPARTMENT,SALES))),||,fn(MATCH_ROLE,Customer Service | Artwork)))"
        },
        {
          "groupItems": [
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "checkbox",
                  "variable": "formData.product.hasFOC",
                  "label": "Has FOC",
                  "disabled": "FALSE",
                  "showIf": "{{formData.product.productLine}}"
                },
                {
                  "type": "checkbox",
                  "variable": "formData.product.allowPriceBracket",
                  "label": "Allow Price Bracket",
                  "disabled": "fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(LOGICAL,fn(CONCAT,',{{__arrayItem.status}},'),==,'Approved'),{{formData.product.priceBracket}}),>,1)",
                  "showIf": "{{formData.product.productLine}}"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "disabled": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))",
          "label": "Commercial Specs"
        },
        {
          "groupItems": [
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Price Bracket",
                  "disabled": "FALSE",
                  "items": "formData.product.priceBracket",
                  "showIf": "{{formData.product.priceBracket}}",
                  "headers": [
                    {
                      "value": "price",
                      "text": "Price in SAR",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,unitPriceFormat,{{__item.price}})"
                    },
                    {
                      "value": "minimumQuantity",
                      "text": "Minimum Quantity",
                      "type": "formula",
                      "formula": "{{__item.minimumQuantity}} {{formData.product.unit.unit2}}"
                    },
                    {
                      "value": "status",
                      "text": "Status"
                    },
                    {
                      "value": "actions",
                      "text": "Actions",
                      "type": "actions",
                      "showIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)),&&,fn(LOGICAL,fn(LENGTH,{{formData.product.priceBracket}}),>,1))",
                      "useMenu": false,
                      "actions": [
                        {
                          "label": "Reject",
                          "showIf": "fn(LOGICAL,fn(LOGICAL,{{formData.product.allowPriceBracket}},==,true),||,fn(LOGICAL,fn(CONCAT,',{{__item.status}},'),==,'Pending'))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "rejectPrice",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v2/product-price/{{__item._id}}/reject",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE"
                              },
                              "name": "rejectPrice"
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "tableType": "static",
                  "showActions": true,
                  "fontSize": "0.75rem"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "showIf": "fn(LOGICAL,fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(MATCH_ROLE,Sales | Account Executive)),||,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))),||,fn(MATCH_ROLE,Customer Service | Manager))",
          "label": "Price Bracket"
        },
        {
          "groupItems": [
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Update",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openProductAliasPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Confirm Product Alias"
                      },
                      "name": "openProductAliasPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.status}},'),!=,'Closed')",
                  "color": "green"
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,QA_TECHNICAL_EXECUTIVE))"
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Update",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openProductAliasPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Confirm Product Alias"
                      },
                      "name": "openProductAliasPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.status}},'),!=,'Closed')",
                  "color": "green"
                },
                {
                  "type": "button",
                  "label": "Submit Draft",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "submitProduct",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/product/{{__params.productId}}/submit",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "requestMethod",
                        "arg3Value": "PATCH",
                        "arg4Key": "refreshPage",
                        "arg4Value": "TRUE"
                      },
                      "name": "submitProduct"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.status}},'),==,'Draft')",
                  "color": "secondary"
                },
                {
                  "type": "button",
                  "label": "View Price History",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "getPriceHistory",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/product/{{__params.productId}}/price-history",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.priceHistory"
                      },
                      "name": "getPriceHistory"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "openPriceHistoryPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Price History"
                      },
                      "name": "openPriceHistoryPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LENGTH,{{formData.product.priceBracket}}),>,0)",
                  "color": "primary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_DEPARTMENT,SALES))"
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Close",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "disableProduct",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v2/product/{{__params.productId}}/mark-disabled",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "fnsAfterSubmit",
                        "arg3Value": "redirectToProductMaster"
                      },
                      "name": "disableProduct"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.status}},'),!=,'Closed')",
                  "color": "error"
                },
                {
                  "type": "button",
                  "label": "Reject",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "markProductAsDraft",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/product/{{__params.productId}}/mark-as-draft",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "requestMethod",
                        "arg3Value": "PATCH",
                        "arg4Key": "fnsAfterSubmit",
                        "arg4Value": "redirectToProductMaster"
                      },
                      "name": "markProductAsDraft"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.status}},'),==,'Pending')",
                  "color": "secondary"
                },
                {
                  "type": "button",
                  "label": "Approve",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "approveProduct",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/product/{{__params.productId}}/approve",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "requestMethod",
                        "arg3Value": "PATCH",
                        "arg4Key": "fnsAfterSubmit",
                        "arg4Value": "redirectToProductMaster"
                      },
                      "name": "approveProduct"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.status}},'),==,'Pending')",
                  "color": "primary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,QA_TECHNICAL_EXECUTIVE)),||,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))"
            },
            {
              "name": "8",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Update Artwork",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyPrintingForm",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getPrintingForm",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.printingForm"
                      },
                      "name": "copyPrintingForm"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "updatePrinting",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/product/update-printing",
                        "arg2Key": "postData",
                        "arg2Value": "fetchedData.printingForm",
                        "arg3Key": "fnsAfterSubmit",
                        "arg3Value": "redirectToProductMaster"
                      },
                      "name": "updatePrinting"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "green"
                }
              ],
              "showIf": "fn(MATCH_ROLE,Customer Service | Artwork)"
            },
            {
              "name": "9",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Delete",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "deleteProduct",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/product/{{__params.productId}}/delete",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "requestMethod",
                        "arg3Value": "PATCH",
                        "arg4Key": "fnsAfterSubmit",
                        "arg4Value": "redirectToProductMaster"
                      },
                      "name": "deleteProduct"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.status}},'),==,'Closed')",
                  "color": "error"
                },
                {
                  "type": "button",
                  "label": "Reactivate",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "reactivateProduct",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/product/{{__params.productId}}/activate",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "requestMethod",
                        "arg3Value": "PATCH",
                        "arg4Key": "fnsAfterSubmit",
                        "arg4Value": "redirectToProductMaster"
                      },
                      "name": "reactivateProduct"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.product.status}},'),==,'Closed')",
                  "color": "primary"
                }
              ],
              "showIf": "fn(MATCH_ROLE,Sales | Manager)"
            },
            {
              "name": "9",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Reactivate",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "reactivateProduct",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/product/{{__params.productId}}/activate",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "requestMethod",
                        "arg3Value": "PATCH",
                        "arg4Key": "fnsAfterSubmit",
                        "arg4Value": "redirectToProductMaster"
                      },
                      "name": "reactivateProduct"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.product.status}},'),==,'Open'),&&,fn(LOGICAL,fn(CONCAT,',{{formData.product.productState}},'),==,'Inactive'))",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(MATCH_ROLE,Sales | Manager)"
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "button",
                  "label": "View Sample History",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "copySampleSearchObject",
                      "pageFunction": {
                        "name": "copySampleSearchObject",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDefaultSampleSearchObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.sampleSearch",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      }
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyProductIdToSampleSearchObject",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__params.productId",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.sampleSearch.q.product"
                      },
                      "name": "copyProductIdToSampleSearchObject"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "getProductSamples",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/sample/search",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.productSamples",
                        "arg3Key": "postData",
                        "arg3Value": "fetchedData.sampleSearch"
                      },
                      "name": "getProductSamples"
                    },
                    {
                      "executionOrder": 4,
                      "pageFunction": {
                        "name": "openSampleHistoryPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Sample History"
                      },
                      "name": "openSampleHistoryPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,QA_TECHNICAL_EXECUTIVE)),||,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_DEPARTMENT,SALES)))",
                  "color": "primary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.product.status}},'),!=,'Draft'),&&,fn(LOGICAL,fn(CONCAT,',{{formData.product.status}},'),!=,'Pending'))"
            }
          ],
          "showIf": "fn(NOT,{{formData.product.isDeleted}})",
          "type": "genericGroup"
        },
        {
          "type": "popupGroup",
          "label": "Confirm Product Alias",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Please verify the Product Alias is updated as required."
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.product.alias",
                  "label": "Alias",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Update Product",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "updateProduct",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/product/update",
                    "arg2Key": "postData",
                    "arg2Value": "formData.product",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  },
                  "name": "updateProduct"
                }
              ]
            }
          ],
          "width": "600"
        },
        {
          "type": "popupGroup",
          "label": "Price History",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Price History",
                  "disabled": "FALSE",
                  "items": "fetchedData.priceHistory.data",
                  "showIf": "{{fetchedData.priceHistory.data}}",
                  "headers": [
                    {
                      "value": "updatedAt",
                      "text": "Date",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                    },
                    {
                      "value": "price",
                      "text": "Price in SAR",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,unitPriceFormat,{{__item.price}})"
                    },
                    {
                      "value": "minimumQuantity",
                      "text": "Minimum Quantity",
                      "type": "formula",
                      "formula": "{{__item.minimumQuantity}} {{formData.product.unit.unit2}}"
                    },
                    {
                      "value": "quantity",
                      "text": "Last Order Quantity",
                      "type": "formula",
                      "formula": "{{__item.quantity}} {{formData.product.unit.unit2}}"
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "fontSize": "0.75rem"
                }
              ]
            }
          ],
          "width": "600"
        },
        {
          "type": "popupGroup",
          "label": "Sample History",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                      "type": "table",
                      "label": "Product Sample",
                      "disabled": "FALSE",
                      "items": "fetchedData.productSamples.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Sample",
                          "type": "url",
                          "url": "/sample/{{__item._id}}"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(CONCAT,{{__item.quantity}}, ,{{__item.unit}},(s))"
                        },
                        {
                          "value": "__item.deliverTo",
                          "text": "Deliver To"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.sampleSearch.page",
                        "serverItemsLengthVariable": "fetchedData.productSamples.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.sampleSearch.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getProductSamples",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/sample/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.productSamples",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.sampleSearch"
                            },
                            "name": "getProductSamples"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
              ]
            }
          ],
          "width": "700"
        }
      ],
      "useMaxPageWidth": true,
      "pageComments": {
        "commentsVariable": "formData.product.comments",
        "newCommentVariable": "fetchedData.commentsForm.text",
        "addComentAction": [
          {
            "executionOrder": 1,
            "name": "copyDefaultModel",
            "pageFunction": {
              "name": "copyDefaultModel",
              "type": "fnCopyData",
              "arg1Key": "sourceFn",
              "arg1Value": "getDefaultModel",
              "arg2Key": "destinationKey",
              "arg2Value": "fetchedData.commentsForm"
            }
          },
          {
            "executionOrder": 2,
            "pageFunction": {
              "name": "addComment",
              "type": "fnSubmit",
              "arg1Key": "apiUrl",
              "arg1Value": "/api/v1/comment/product/{{__params.productId}}/add",
              "arg2Key": "postData",
              "arg2Value": "fetchedData.commentsForm",
              "arg3Key": "refreshPage",
              "arg3Value": "TRUE"
            },
            "name": "addComment"
          }
        ],
        "deleteCommentAction": [
          {
            "executionOrder": 1,
            "pageFunction": {
              "name": "copyCommentId",
              "type": "fnCopyData",
              "arg1Key": "sourceKey",
              "arg1Value": "__item._id",
              "arg2Key": "destinationKey",
              "arg2Value": "fetchedData.commentId"
            },
            "name": "copyCommentId"
          },
          {
            "executionOrder": 2,
            "pageFunction": {
              "name": "deleteComment",
              "type": "fnSubmit",
              "arg1Key": "apiUrl",
              "arg1Value": "/api/v1/comment/{{fetchedData.commentId}}/delete?model=product",
              "arg2Key": "postData",
              "arg2Value": "{}",
              "arg3Key": "requestMethod",
              "arg3Value": "DELETE",
              "arg4Key": "refreshPage",
              "arg4Value": "TRUE"
            },
            "name": "deleteComment"
          }
        ],
        "updateCommentAction": [
          {
            "executionOrder": 1,
            "pageFunction": {
              "name": "copyCommentId",
              "type": "fnCopyData",
              "arg1Key": "sourceKey",
              "arg1Value": "__item._id",
              "arg2Key": "destinationKey",
              "arg2Value": "fetchedData.commentId"
            },
            "name": "copyCommentId"
          },
          {
            "executionOrder": 2,
            "pageFunction": {
              "name": "copyEditCommentTextForm",
              "type": "fnCopyData",
              "arg1Key": "sourceKey",
              "arg1Value": "__item",
              "arg2Key": "sourceFn",
              "arg2Value": "getEditCommentTextForm",
              "arg3Key": "destinationKey",
              "arg3Value": "fetchedData.editedCommentForm"
            },
            "name": "copyEditCommentTextForm"
          },
          {
            "executionOrder": 3,
            "pageFunction": {
              "name": "updateComment",
              "type": "fnSubmit",
              "arg1Key": "apiUrl",
              "arg1Value": "/api/v1/comment/{{fetchedData.commentId}}/edit",
              "arg2Key": "postData",
              "arg2Value": "fetchedData.editedCommentForm",
              "arg3Key": "requestMethod",
              "arg3Value": "PATCH",
              "arg4Key": "refreshPage",
              "arg4Value": "TRUE"
            },
            "name": "updateComment"
          }
        ],
        "showIf": "fn(NOT,fn(MATCH_ROLE,Production | Operator))"
      }
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getProductLines",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=product-lines1",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.productLines"
        },
        "name": "getProductLines"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllRmAliases",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/rm-alias/get",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.rmAliases"
        },
        "name": "getAllRmAliases"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllFeatureFlags",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=feature-flags",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.featureFlags"
        },
        "name": "getAllRmAliases"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyProductEditFlag",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "fetchedData.featureFlags.data.0.data.value",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.allowDraftProductEdit"
        },
        "name": "copyProductEditFlag"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyProductForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getProductForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.productForm"
        },
        "name": "copyProductForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getProductData",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/product/detail",
          "arg2Key": "storeInVar",
          "arg2Value": "formData",
          "arg3Key": "sourceTransformationFn",
          "arg3Value": "transformProductData",
          "arg4Key": "postData",
          "arg4Value": "fetchedData.productForm"
        },
        "name": "getProductData"
      }
    ],
    "functions": [
      {
        "name": "transformProductData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "product": "__selectedObject.data"
        }
      },
      {
        "name": "getFormValues",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "customer": "__selectedObject.customer",
          "productLine": "__selectedObject.productLine"
        }
      },
      {
        "name": "redirectToProductMaster",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/product-master/{{formData.product.customer._id}}"
      },
      {
        "name": "getProductForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "id": "{{__params.productId}}",
          "includeModifications": "fn(LOGICAL,1,==,1)",
          "modificationsLimit": "fn(SUM,1,0)"
        },
        "useFormula": true
      },
      {
        "name": "getPrintingForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "id": "formData.product._id",
          "printing": "formData.product.printing"
        }
      },
      {
        "name": "getDefaultModel",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "model": "product",
          "text": "{{fetchedData.commentsForm.text}}"
        },
        "useFormula": true
      },
      {
        "name": "getEditCommentTextForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "text": "__item.text",
          "model": "__item.targetModel"
        }
      },
      {
        "name": "getDefaultSampleSearchObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 10,
          "q": {}
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "*",
  "visible": false
}